export default __webpack_public_path__ + "static/media/1945.b989a89e.png";